import { callBackendApi } from "src/components/service/axios";
import { SystemUserGroup } from "../models/system-user-group";

export const fetchInformationUserGroups = async (
  group_ids: string[]
): Promise<SystemUserGroup[]> => {
  return await callBackendApi("post", "/bff/system-user-groups", { ids: group_ids });
};

export const fetchAllSystemUserGroups = async (): Promise<SystemUserGroup[]> => {
  return await callBackendApi("get", "/bff/system-user-groups");
};